const anm = {
   from: { opacity: 1 },
   enter: { opacity: 1 },
   leave: { opacity: 1 },
   config: { duration: 1}

}

export default anm
